
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StepList from "@/components/scope/step-list.vue";
import dayjs from "dayjs";
import ConfirmPaymentItem from "@/views/purchase/components/confirm-payment.vue";
import RegisterInvoice from "@/views/purchase/components/register-invoice.vue";
import { addCurrencyUnit } from "@common/src/utils/tools";

const purchase = namespace("purchase");
const app = namespace("app");
const finance = namespace("finance");

@Component({
  components: {
    StepList,
    ConfirmPaymentItem,
    RegisterInvoice
  }
})
export default class PurchaseSettlementView extends Vue {
  @purchase.Action purchaseCancel;
  @finance.Action queryPurchaseBillDetail;
  @finance.Action createPurchaseBillInvoice;
  @finance.Action createPurchaseBillSettlement;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    return [
      { name: this.$t("finance.procurement-settlement"), path: "/finance/purchase-settlement" },
      { name: this.$t("finance.statement-details") }
    ];
  }
  created() {
    this.init();
  }
  handleMoreMenuClick(command) {
    if (command === "cancel") {
      this.purchaseCancel({
        purchaseNo: this.orderId
      }).then(() => {
        this.$message.success(this.$t("finance.cancel-success") as string);
        this.init();
      });
    }
  }
  handlePaymentConfirmClick(data) {
    console.log(data);
    let params = {
      billNo: this.orderId,
      paidMethod: data.paidMethod
    };
    this.setPaymentBtnLoading(true);
    this.createPurchaseBillSettlement(params)
      .then(() => {
        this.$message.success(this.$t("base.payment-success") as string);
        this.showComfirmPayment = false;
        this.init();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  handleInvoiceConfirmClick(data) {
    console.log(data);
    this.setMakeInvoiceBtnLoading(true);
    this.createPurchaseBillInvoice(
      Object.assign(data, {
        billNo: this.orderId
      })
    )
      .then(() => {
        this.$message.success(this.$t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.init();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  get orderId() {
    return this.$route.params.id;
  }
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  emptyToLine = emptyToLine;
  detailData: any = { orderList: [] };
  handleComfirmPaymentShow() {
    this.showComfirmPayment = true;
  }
  handleRegisterInvoice() {
    this.showRegisterInvoice = true;
  }
  handleArriveStore() {
    this.$router.push(`/service/arrive/input/${this.orderId}`);
  }

  init() {
    this.queryPurchaseBillDetail({
      billNo: this.orderId
    }).then(data => {
      data.data.purchaseAmount = data.data.billAmount;
      data.data.purchaseNo = data.data.billNo;
      this.detailData = data.data;
    });
  }
}
